import { memo } from 'react'
import styles from './BorderBase.module.scss'

/**
 * The `BorderBase` renders the base border of the HUD
 *
 * @returns {React.ReactElement} the element
 */
function BorderBase () {
  return (
    <div aria-hidden="true">
      <div className={styles.borderSolid}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className={styles.borderStrokeTop} />
      <div className={styles.borderStrokeBottom} />
    </div>
  )
}

// Memoize
export default memo(BorderBase)
